import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useColors} from '../../../../hooks/colors'
import {useAppActions, useAppSelector} from '../../../../hooks/runtime'
import {isInDescription} from '../../../../selectors/seating/mode'
import {isPlaceInBasket, isPlaceReservableAsWhole} from '../../../../selectors/seating/place'
import {TicketProps} from './interfaces'
import {TicketAction} from './ticket-action'
import {TicketInfo} from './ticket-info'
import {classes} from './ticket.st.css'

export const Ticket = ({
  place,
  showAccessibilityMode,
  onClick,
  onTicketMoreInfoClick,
  setForcedPopoverPlanPlaceId,
  basketView = false,
  origin,
}: TicketProps) => {
  const inBasket = isPlaceInBasket(place)
  const {darkColor} = useColors()
  const {isMobile} = useEnvironment()
  const wholeElementReservation = isPlaceReservableAsWhole(place)
  const {resetAreaCounterValue, selectPlace, unselectPlace} = useAppActions()

  const inDescription = useAppSelector(isInDescription)

  const handleClick: React.MouseEventHandler<HTMLButtonElement | HTMLLIElement> = e => {
    e.stopPropagation()
    onClick?.(place)
  }

  const handleTicketMoreInfoClick: React.MouseEventHandler<HTMLButtonElement> = e => {
    e.stopPropagation()
    handleUnselectSeat()
    resetAreaCounterValue({place})
    onTicketMoreInfoClick?.(place)
  }

  const handleSelectSeat = () => {
    setForcedPopoverPlanPlaceId?.(place.planPlaceId)

    if (showAccessibilityMode && !inDescription) {
      selectPlace(place.planPlaceId)
    }
  }

  const handleUnselectSeat = () => {
    setForcedPopoverPlanPlaceId?.(null)

    if (showAccessibilityMode && !inDescription) {
      unselectPlace()
    }
  }

  const onTicketClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    if (!inDescription && !basketView) {
      handleClick(event)
    }
  }

  return (
    <>
      <li
        className={classNames(classes.ticket, {
          [classes.selectedWired]: !inDescription && showAccessibilityMode && !basketView && inBasket && darkColor,
          [classes.selectedNotWired]: showAccessibilityMode && !basketView && inBasket && !darkColor,
          [classes.ticketHoverBorder]: !inDescription && !isMobile,
          [classes.ticketHoverCursor]: !basketView && !inDescription && !isMobile,
          [classes.ticketMultiBorder]: wholeElementReservation,
          [classes.mobile]: isMobile,
        })}
        onClick={onTicketClick}
        onMouseEnter={handleSelectSeat}
        onMouseLeave={handleUnselectSeat}
        onFocus={handleSelectSeat}
        onBlur={handleUnselectSeat}
        data-hook={`ticket-${place.id}`}
      >
        {wholeElementReservation ? (
          <div className={classNames(classes.multiBorder, {[classes.mobile]: isMobile})} />
        ) : null}
        <div className={classes.color} style={{backgroundColor: place.color}} />
        <TicketInfo
          inDescription={inDescription}
          basketView={basketView}
          place={place}
          showAccessibilityMode={showAccessibilityMode}
        />
        <TicketAction
          place={place}
          inDescription={inDescription}
          onClick={handleClick}
          onTicketMoreInfoClick={handleTicketMoreInfoClick}
          basketView={basketView}
          showAccessibilityMode={showAccessibilityMode}
          origin={origin}
        />
      </li>
    </>
  )
}
